import React from 'react';
import { Box, FormControlLabel } from '@mui/material';
import CheckboxCustom from '../../components/checkbox';
import i18n from '../../i18';

class DialogCheckboxField extends React.Component {
    handleCheckboxChanged = (event, checked) => {
        this.props.onChange(this.props.field.id, checked);
    };
    render() {
        const translatedLabel = i18n.t(`columns.${this.props.field.label}`);
        const required = this.props.field.required;
        const requiredLabel = required ? ' *' : '';
        return (
            <Box ml={1} mb={2}>
                <FormControlLabel
                    slotProps={{ typography: { ml: 1 } }}
                    control={
                        <CheckboxCustom
                            id={this.props.field.id}
                            checked={
                                this.props.value !== null &&
                                this.props.value !== undefined
                                    ? !!this.props.value
                                    : !!this.props.field.defaultValue
                            }
                            onChange={(event, checked) =>
                                this.handleCheckboxChanged(event, checked)
                            }
                        />
                    }
                    label={translatedLabel + requiredLabel}
                />
            </Box>
        );
    }
}

export default DialogCheckboxField;
